<ng-template #blockTemplate>
    <div style="display: block; padding-top: 8px">
        <app-selector [height]="'14px'" [width]="'35%'"></app-selector>
        <app-selector [height]="'14px'" [width]="'15%'" [style]="{ float: 'right' }"></app-selector>
    </div>
</ng-template>

<ng-template #billLoader>
    <div class="bill-breakup">
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <hr class="seprator" />
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
        <hr class="seprator" />
        <ng-template [ngTemplateOutlet]="blockTemplate"></ng-template>
    </div>
</ng-template>

<ng-template #billPrice let-amount="amount" let-gross_total="gross_total" let-type="type">
    <div style="display: flex">
        @if (amount !== gross_total) {
            <div style="text-decoration: line-through; margin-right: 4px">{{ gross_total | rupee }}</div>
        }

        @if (!amount && gross_total > amount && type !== 'Non-Saving') {
            <div class="free-label">FREE</div>
        } @else {
            <div>{{ amount | rupee }}</div>
        }
    </div>
</ng-template>

<div class="bill-details-wrapper">
    <mat-accordion>
        <mat-expansion-panel [expanded]="expanded" (opened)="onPanelOpen()">
            <mat-expansion-panel-header class="panel-header">
                <mat-panel-title>
                    <span class="title">BILL DETAILS</span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            @if (isCartUpdating) {
                <ng-template [ngTemplateOutlet]="billLoader"></ng-template>
            } @else {
                <div class="bill-breakup">
                    <div class="item">
                        <div>Sub Total</div>
                        <div>{{ serverCart?.gross_total | rupee }}</div>
                    </div>
                    @for (charge of getBillDetails(); track charge) {
                        <div class="item">
                            <div style="display: flex">
                                <div
                                    [ngStyle]="{
                                        'text-decoration': charge.sub_charges.length ? 'underline' : 'none',
                                        cursor: charge.sub_charges.length ? 'pointer' : 'default',
                                        '-webkit-tap-highlight-color': 'transparent'
                                    }"
                                    (click)="charge.sub_charges.length && openFloatingView(charge.sub_charges, charge.name)">
                                    {{ charge.name }}
                                </div>

                                @if (charge.message) {
                                    <div class="charge-message">
                                        {{ charge.message.trim().substr(0, 30) + '..' }}
                                    </div>
                                }
                            </div>
                            <ng-container
                                *ngTemplateOutlet="
                                    billPrice;
                                    context: {
                                        amount: isCreditsUsed() ? charge.amount_with_credit : charge.amount,
                                        gross_total: charge.gross_total,
                                        type: charge.type
                                    }
                                "></ng-container>
                        </div>
                    }
                    @if (!isCreditsUsed() && serverCart?.round_off) {
                        <div class="item">
                            <div>Round Off</div>
                            <div>{{ serverCart?.round_off | rupee }}</div>
                        </div>
                    } @else {
                        @if (isCreditsUsed() && serverCart?.round_off_with_credits) {
                            <div class="item">
                                <div>Round Off</div>
                                <div>{{ serverCart?.round_off_with_credits | rupee }}</div>
                            </div>
                        }
                    }
                    @if (isMobile) {
                        <div class="item total">
                            <div>Total Payable</div>
                            <div>{{ getFinalCartPrice() | rupee }}</div>
                        </div>
                        @if (getTotalSavings()) {
                            <span class="saved-section" (click)="openFloatingView(serverCart.total_saving, 'Savings')">
                                Congrats! You have saved&nbsp;
                                <strong>{{ getTotalSavings() | rupee }} </strong>&nbsp;on this&nbsp;
                                <span class="order-info">
                                    order
                                    <img src="{{ DEPLOY_URL }}/assets/images/info.svg" class="info-icon" width="15" />
                                </span>
                            </span>
                        }
                    }
                </div>
            }
        </mat-expansion-panel>
    </mat-accordion>
</div>
